<template>
  <div>
    <NuxtPage page-key="static" />
  </div>
</template>
